import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import I18NextVue from 'i18next-vue'
import { initI18n } from 'www/utils'
import MarkOfShame from 'www/vue_components/common/MarkOfShame/MarkOfShame.vue'

const elements = [...document.querySelectorAll('.vue-mark-of-shame')]

const mountMarkOfShame = async () => {
  if (elements) {
    const { i18next } = await initI18n({ bundle: 'vue_components/common/MarkOfShame' })

    Vue.use(I18NextVue, { i18next })

    elements.forEach(el => {
      new Vue({
        el,
        vuetify,
        name: 'MarkOfShameRoot',
        components: { MarkOfShame },
      })
    })
  }
}

mountMarkOfShame()
